import { useTanFetch } from './useTanFetch';
import { ApiResponse, UsageStats } from '@/types';

export function useUsageStats() {
  return useTanFetch<ApiResponse<UsageStats>>(['usage'], true);
}